import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import API from '../../tools/API';
import styles from './SingleOption.module.scss';

interface SingleSetting {
    id: number,
    name: string,
    noOfResults: number,
    maxVotingTimeForAnOption: number,
    isSmsVoting: boolean
}


const SingleOption = () => {
    const { id } = useParams();

    const [singleSetting, setSingleSetting] = useState<SingleSetting | null>(null);
    useEffect(() => {
        if (id) {
            API.getSingleSetting(id).then(res => setSingleSetting(res?.data.data))
        }
    }, []);

    return (
        <section className={styles.singleOptions}>
            {singleSetting && (
                <div className={styles.singleOptions__container}>
                    <h2 className={styles.singleOptions__header}>
                        {singleSetting.name}
                    </h2>
                    <p className={styles.singleOptions__text}>Liczba wyników: {singleSetting.noOfResults}</p>
                    <p className={styles.singleOptions__text}>Maksymalny czas głosu na opcje: {singleSetting.maxVotingTimeForAnOption ? singleSetting.maxVotingTimeForAnOption : 'Brak'}</p>
                    <p className={styles.singleOptions__text}>Głosowanie SMS: {singleSetting.isSmsVoting ? 'Tak' : 'Nie'}</p>
                </div>
            )}
        </section>
    )
}

export default SingleOption;